var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-danger btn-lg mh-btn btn-block",on:{"click":_vm.clockOut}},[_vm._v("Clock Out")])
}
var staticRenderFns = []

export { render, staticRenderFns }